import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionsGuard } from '@core/guard/permissions.guard';
import { PageGenerateSelectionComponent } from './page-generate-selection/page-generate-selection.component';

const routes: Routes = [
  {
    path: '',
    component: PageGenerateSelectionComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['core.generate-selection.get'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesGenerateSelectionRoutingModule { }
